import React, { Component } from "react";
import { Table, Button, Input, Switch, Modal, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import UsuarioForm from '../components/UsuarioForm';
import moment from "moment";
import { maskCPF } from "../utils/Masker";
import { getUsuario } from "../utils/LoginManager";

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Search } = Input;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    novoReg: false,
    buscaOrdem: { campo: 'usu_nome', ordem: 'ASC' },
  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
    this.getListaRegistros();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true });
    const { busca, pagina, limite, buscaOrdem } = this.state;
    axios
      .get('/usuarios', {
        params: {
          page: pagina,
          limite: limite,
          campoOrdem: buscaOrdem.campo,
          tipoOrdem: buscaOrdem.ordem,
          nome: busca,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };




  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    let request;
    if (this.state.novoReg === false) { //editar      
      request = axios.put(`/usuarios/update/${registro.usu_idf}`, registro);
    } else { // cadastrar
      request = axios.post(`/usuarios/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Usuário gravado com sucesso.');
      })
      .catch(error => {
        let mensagem = '';
        if (error.response.data.usu_cpf) {
          mensagem = error.response.data.usu_cpf;
        } else if (error.response.data.usu_email) {
          mensagem = error.response.data.usu_email;
        } else if (error.response.data.usu_nome) {
          mensagem = error.response.data.usu_nome;
        } else if (error.response.status === 500) {
          mensagem = error.response.data;
        }

        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Falha - Atenção!', content: 'Não foi possível salvar. ' + mensagem, okText: 'OK', })
      })
  }


  onEditarClick = registro => {
    this.setState({ carregando: true });
    axios.get(`/usuarios/show/${registro.usu_idf}`)
      .then(response => {
        const { data } = response;

        data.usu_cpf = data.usu_cpf ? maskCPF(data.usu_cpf) : '';

        data.ue_grupo = {
          key: String(data.ue_grupo),
          label: data.gu_descricao,
        }

        this.setState({
          formVisivel: true,
          registroSelecionado: data,
          carregando: false,
          novoReg: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/usuarios/delete/${registro.usu_idf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.usu_idf === registro.usu_idf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
          })
      }
    })
  };


  onEsqueciSenhaClick = (registro) => {
    Modal.confirm({
      title: 'Confirmação',
      content: `Deseja redefinir a senha deste Usuário?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });

        axios.get('/usuarios/enviaEmailRedefinirSenha', {
          params: {
            usuario: registro.usu_email,
            empresa: this.state.usuario.emp_codigo,
          }
        }).then(response => {
          Modal.success({ title: 'Sucesso', content: 'Senha redefinida, sua nova senha foi enviada para o teu email', okText: 'OK', })
          this.setState({ carregando: false });
        }).catch(error => {
          Modal.error({ title: 'Atenção!', content: error.response.data.mensagem, okText: 'OK', })
          console.log(error.response);
          this.setState({ carregando: false });
        })
      }
    })
  }



  onBuscar = (texto) => {
    this.setState({
      busca: texto
    },
      this.getListaRegistros);
  };

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      novoReg: true,
      registroSelecionado: {
        novoReg: true,
        checkedDescPerc: false,
        usu_idf: 0,
        ue_grupo: { key: '' }
      },
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }


  onAtivaChange = (registro, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/usuarios/ativa/${registro.usu_idf}/1`)
    } else {
      request = axios.put(`/usuarios/ativa/${registro.usu_idf}/0`)
    }

    request.then(response => {
      registro.ue_status = ativar;
      this.setState({
        listaRegistros: this.state.listaRegistros.concat([]),
        carregando: false
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false
      })
    })
  };


  renderAtiva = (ue_status, registro) => {
    return (
      <Switch
        checkedChildren="Ativo"
        unCheckedChildren="Inativo"
        checked={ue_status}
        onChange={ativar => this.onAtivaChange(registro, ativar)}
      />
    );
  };

  renderVendedor = (ue_vendedor, registro) => {
    return (
      <span>
        {ue_vendedor ? 'SIM' : 'NÃO'}
      </span>
    );
  };


  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Editar">
          <Button type="primary" size="small" onClick={() => this.onEditarClick(registro)} icon="edit" />
        </Tooltip>
        <Tooltip title="Excluir">
          <Button type="danger" size="small" disabled={this.state.listaRegistros.length === 1} onClick={() => this.onExcluirClick(registro)} icon="delete" />
        </Tooltip>
        <Tooltip title="Redefinir Senha">
          <Button type="default" size="small" disabled={this.state.listaRegistros.length === 1} onClick={() => this.onEsqueciSenhaClick(registro)} icon="key" />
        </Tooltip>
      </ButtonGroup>
    );
  };

  renderData = (data) => {
    const dataMoment = moment(data);
    return (
      <span>
        {dataMoment.format('DD/MM/YYYY HH:mm')}
      </span>
    )
  }

  renderCPF = (usu_cpf) => {
    return maskCPF(usu_cpf);
  }

  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })

  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = this.state.buscaOrdem.campo && this.state.buscaOrdem.campo === column.dataIndex ? (this.state.buscaOrdem.ordem && this.state.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    this.state['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, salvando, registroSelecionado,
      total, pagina, limite } = this.state;


    // console.log('UsuariosPage: ', this.state)

    return (
      <div className="contentRoutesContainer">
        <span className="tituloPage">Usuários</span>
        <div className="divider-page1" />

        <div className="pageFiltro">
          <Button
            type="primary"
            onClick={this.onAdicionarClick}
            className="botao-primary"
          >
            Adicionar
          </Button>

          <Search
            placeholder="Buscar por Nome do Usuário"
            onSearch={this.onBuscar}
            enterButton
            className="pageFiltro-busca"
          />

          <UsuarioForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />
        </div>

        <br />

        <Table
          pagination={{
            total: total,
            pageSize: limite,
            current: pagina,
            pageSizeOptions: ['10', '20', '30', '40', '50'],
            showSizeChanger: true,
          }}
          onChange={this.onTabelaChange}
          loading={{
            spinning: carregando,
            tip: 'Carregando. Aguarde...',
            size: "large"
          }}
          dataSource={listaRegistros}
          rowKey={(registro => registro.usu_idf)}
          scroll={{ x: 600 }}
        >
          <Column
            key="usu_nome"
            dataIndex="usu_nome"
            title={this.renderTitulo("Nome")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={200}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="usu_email"
            dataIndex="usu_email"
            title={this.renderTitulo("Email")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={150}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="usu_fone"
            dataIndex="usu_fone"
            title={this.renderTitulo("Telefone")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={120}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="gu_descricao"
            dataIndex="gu_descricao"
            title={this.renderTitulo("Grupo")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={90}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="ue_vendedor"
            dataIndex="ue_vendedor"
            title={this.renderTitulo("Vendedor")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={80}
            align="center"
            className="listaCadastro"
            render={this.renderVendedor}
          />
          <Column
            key="ue_acesso_sistema"
            dataIndex="ue_acesso_sistema"
            title={this.renderTitulo("Acesso Sistema")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            render={this.renderVendedor}
            width={40}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="ue_dt_ult_acesso"
            dataIndex="ue_dt_ult_acesso"
            title={this.renderTitulo("Último Acesso")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            width={80}
            align="center"
            render={this.renderData}
            className="listaCadastro"
          />
          <Column
            key="ue_status"
            dataIndex="ue_status"
            title={this.renderTitulo("Situação")}
            onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
            render={this.renderAtiva}
            width={40}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="acoes"
            title={<div style={{ background: "#ececec", padding: 2, marginLeft: -5, marginRight: -5 }}>.</div>}
            render={this.renderAcoes}
            width={70}
            align="center"
            className="listaCadastro"
          />
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/UsuariosPage.js